import { render, staticRenderFns } from "./ApprovalTypeInitiatorsComponent.vue?vue&type=template&id=49e30af0"
import script from "./ApprovalTypeInitiatorsComponent.vue?vue&type=script&lang=js"
export * from "./ApprovalTypeInitiatorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports